const baseURL = "/v1/SolicitacoesDeAcesso";

const service = {
  methods: {
    $buscarSolicitacoesDeAcessoADM(params) {
      return this.$api().get(`${baseURL}/Adm`, params);
    },
    $buscarSolicitacoesDeAcessoGGEIAI(params) {
      return this.$api().get(`${baseURL}/Ggeiai`, params);
    },
    $visualizarSolicitacoesDeAcesso({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $editarSolicitacoesDeAcesso(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $envioDeEmailSolicitacoesDeAcesso(body, id) {
      return this.$api().post(`${baseURL}/${id}/EnviarEmailDeConfirmacao`, body);
    },
    $buscarSituacoesSolicitacoesDeAcesso(params) {
      return this.$api().get(`${baseURL}/SituacoesDaSolicitacaoDeAcesso`, params);
    },
    $buscarPerfisSolicitacoesDeAcesso(params) {
      return this.$api().get(`${baseURL}/PerfisDaSolicitacaoDeAcesso`, params);
    },
    $buscarSolicitacoesDeAcessoArticuladorRegional(params) {
      return this.$api().get(`${baseURL}/Articulador-Regional`, params);
    }
  },
};

export default service;
